import { ConverterType } from '../domain';
export const bytes = {
    types: ['google.protobuf.BytesValue', 'BYTES'],
    [ConverterType.TO_JSON]: {
        transform: (val) => {
            const chars = val.reduce((res, c) => res + String.fromCharCode(c), '');
            return btoa(chars);
        },
    },
    [ConverterType.FROM_JSON]: {
        transform: (val) => {
            return Uint8Array.from(atob(val), (c) => c.charCodeAt(0));
        },
    },
};
//# sourceMappingURL=bytes.js.map